<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table th>.cell {
    white-space: pre-wrap;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <el-tabs v-model="active" type="card" @tab-click="handleClick">
        <el-tab-pane name="getProductReview">
          <template #label>
            <span><i class="el-icon-date"></i> 专家投票</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <el-form ref="form" :model="queryform" label-width="120px" size="mini" :inline="true">
            <!-- <el-form-item label="药品分类（大类）">
              <el-input v-model="queryform.largeCategory"></el-input>
            </el-form-item>
            <el-form-item label="药品分类（中类）">
              <el-input v-model="queryform.middleCategory"></el-input>
            </el-form-item>
            <el-form-item label="药品分类（小类）">
              <el-input v-model="queryform.smallCategory"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="投票状态">
              <el-select v-model="queryform.status" placeholder="请选择" style="width: 100px;">
                <el-option label="全部" value></el-option>
                <el-option label="已投票" value="1"></el-option>
                <el-option label="未投票" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="getProductReview" round>查&ensp;询</el-button>
            </el-form-item> -->
          </el-form>
          <el-table :data="queryform.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef1">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <!-- <el-table-column prop="largeCategory" label="药品分类（大类）" width="120" align='center'></el-table-column> -->
            <el-table-column prop="middleCategory" label="药品分类（中类）" width="170" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="smallCategory" label="药品分类（小类）" width="170" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="ingredientPathway" label="成分途径" width="170" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="groupGoodsSum" label="采购金额（万）" :formatter="thousandth" width="120" align='right' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="qualityScore" label="厂家数" width="90" align='center'></el-table-column>
            <el-table-column fixed="right" prop="statusName" label="投票状态" align='center'></el-table-column>
            <el-table-column fixed="right" label="操作" width="110" align='center'>
              <template #default="scope">
                <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" :type="scope.row.btnType" v-if="scope.row.fn" size="mini" plain>{{scope.row.operate}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'queryform')" @current-change="(val) => handlePagination(val, null, 'queryform')" @prev-click="(val) => handlePagination(val, null, 'queryform')" @next-click="(val) => handlePagination(val, null, 'queryform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="queryform.pageNo"
            :page-sizes="queryform.pageSizes" :page-size="queryform.pageSize" :total="queryform.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane name="getProductConfirm">
          <template #label>
            <span><i class="el-icon-connection"></i> 品种确认</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <el-form ref="queryform" :model="queryform" label-width="80px">
            <el-row>
              <el-col :span="19">
                <el-form-item label="">
                  <!-- <el-radio-group v-model="queryform.status" @change="getProductPage">
                    <el-radio name="type" :label="8">已中选</el-radio>
                    <el-radio name="type" :label="7">可报价</el-radio>
                    <el-radio name="type" :label="4">已失效</el-radio>
                  </el-radio-group> -->
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="success" icon="el-icon-success" size="small" @click="submitConfirm" :loading="submitButtonLoading" round>一键确认</el-button>
                </el-form-item>
            </el-col>
            </el-row>
          </el-form>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="productList" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef2"
            @selection-change="handleSelectionChange2">
            <el-table-column type="selection" width="55" align='center' prop="id" :reserve-selection="true" :selectable='selectable'></el-table-column>
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <!-- <el-table-column prop="largeCategory" label="药品分类（大类）" width="120" align='center'></el-table-column> -->
            <el-table-column prop="middleCategory" label="药品分类（中类）" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="smallCategory" label="药品分类（小类）" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="ingredientPathway" label="成分途径" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="producerName" label="生产企业" width="180" align='center'></el-table-column>
            <el-table-column prop="goodsSum" label="采购金额（万）" :formatter="thousandth" width="110" align='right' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column fixed="right" prop="statusName" label="确认状态" align='center'></el-table-column>
          </el-table>
          <!-- <el-pagination @size-change="(val) => handlePagination(null, val, 'queryform')" @current-change="(val) => handlePagination(val, null, 'queryform')" @prev-click="(val) => handlePagination(val, null, 'queryform')" @next-click="(val) => handlePagination(val, null, 'queryform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="queryform.pageNo"
            :page-sizes="queryform.pageSizes" :page-size="queryform.pageSize" :total="queryform.total">
          </el-pagination> -->
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>

  <!-- 专家投票 -->
  <el-dialog :title="productGroup.voteGroupName" :visible.sync="dialogFormVisible" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false"
    width="900px" top="150px" marginTop="5px" marginButton="5px">
    <el-table :data="productGroup.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false"
          @selection-change="handleSelectionChange" :row-key="getRowKeys" ref="tableRef" @select-all="selectAll" @select="selectProduct">
      <el-table-column type="selection" width="55" align='center' prop="id" :reserve-selection="true" :selectable='selectable'></el-table-column>
      <el-table-column fixed="left" type="index" label="序号" width="50" align='center' rowspan=2></el-table-column>
      <el-table-column prop="producerName" label="生产企业" width="250" align='center'></el-table-column>
      <el-table-column align="center">
        <template slot="header">
          <div>2023年团体会员单位</div>
        </template>
        <el-table-column prop="goodsSum" label="采购金额（元）" :formatter="thousandth" width="204" align='center' :show-overflow-tooltip='true'></el-table-column>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header">
          <div>供应品规在用医院数</div>
        </template>
        <el-table-column prop="useCountMax" label="（最多）" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="useCountMin" label="（最少）" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
      </el-table-column>
    </el-table>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="operator = -1; prevGroup()"><i class="el-icon-d-arrow-left"></i>&nbsp;上一个</el-button>&emsp;&emsp;&emsp;&emsp;
        <el-button size="mini" type="info" @click="closeDialogForm"><i class="el-icon-circle-close"></i>&ensp;关&ensp;闭</el-button>
        <el-button size="mini" @click="autoSelect"><i class="el-icon-circle-plus-outline"></i>&ensp;勾选{{ productGroup.voteMax }}个</el-button>&ensp;
        <el-badge type="success" :max="100" class="assess-score">
          <el-button size="mini" :loading="submitButtonLoading" type="primary" @click="submitVote()"><i class="el-icon-circle-check"></i>&ensp;提&ensp;交</el-button>
        </el-badge>
        &emsp;&emsp;&emsp;&emsp;<el-button size="mini" @click="operator = 1; nextGroup()">下一个&nbsp;<i class="el-icon-d-arrow-right"></i></el-button>
      </span>
    </template>
  </el-dialog>
<!--
  <template slot="xn-slot" slot-scope="{ data }">
    {{xnItems[data].remark}}
  </template> -->

  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'ExpertReview',
    data(){
      return {
        active: 'getProductReview',
        height: 0,
        operate: false,
        operator: 0,
        submitButtonLoading: false,
        tabPosition: 'left',
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getProductReview', groupCategory: 1, status: null, largeCategory: '', smallCategory: '', middleCategory: ''
        },
        productGroup: {
          voteGroupName: '',
          voteMax: '',
          main: null,
          data: [],
        },
        productList: [],
        dialogFormVisible: false,
        dialogVisible: false,
        multipleSelection: [],
        multipleSelection2: [],
        productRules: {},
        options: [],
        groupMap: new Map()
      };
    },
    mounted(){
      // sessionStorage['/expertreview'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight -350}
    },
    created() {
      this.initView();
    },
    watch: { },
    methods: {
      selectable(d){
        return !d.checked;
      },
      selectAll(){
        this.$refs.tableRef.clearSelection();
      },
      selectProduct(arr, row){
        let voteMax = this.productGroup.main.voteMax;
        if(arr.length > voteMax){
          this.$refs.tableRef.toggleRowSelection(row, false);
          this.$message({ message: `最多可勾选${voteMax}条！`, offset: 200, type: 'error' });
          return;
        }
      },
      thousandth(row, column, cellValue, index){
        if(cellValue && !isNaN(cellValue)){
          let str = new String(cellValue).split('.');
          let re = /\d{1,3}(?=(\d{3})+$)/g;
          let n1 = str[0].replace(re, "$&,");
          return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
        };
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      initView(){
        const self = this
        self.submitButtonLoading = true;
        this.productReviewPage({ groupCategory: 1, pageNo: 1, pageSize: 1000 }).then(res => {
          JSON.parse(res.data.data).forEach((d, index, arr) => {
            this.groupMap.set(index, d)
          })
          this.handleProductReview(res)
        })
      },
      handleClick(tab, event){
        if('string' == typeof event){
          if(this[event]){
            this[event].call(this, tab);
          }
        }else{
          if(this[tab.name]){
            this[tab.name].call(this);
          }
        }
      },
      handleSelectionChange(arr){
        let voteMax = this.productGroup.main.voteMax;
        if(arr.length <= voteMax){
          this.multipleSelection = [...arr];
        }else{
          // console.log(`arr => `, arr);
          // console.log(`multipleSelection => `, this.multipleSelection)
        }
        // console.log(`multipleSelection =>`, this.multipleSelection.length)
      },
      handleSelectionChange2(arr){
        this.multipleSelection2 = [...arr];
      },
      getRowKeys(row) {
        return row.id
      },
      autoSelect(){
        let { voteMax, qualityScore } = { ...this.productGroup.main }
        this.$nextTick(() => {
          this.productGroup.data.forEach((w, index) => {
            if(voteMax > index){
              this.$refs.tableRef.toggleRowSelection(w, true);
            }else{
              this.$refs.tableRef.toggleRowSelection(w, false);
            }
          })
        });
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      getProductReview: function(){
        this.submitButtonLoading = true;
        let{ largeCategory, middleCategory, smallCategory, groupCategory, status, pageNo, pageSize } = this.queryform
        this.productReviewPage({ largeCategory, middleCategory, smallCategory, groupCategory, status, pageNo, pageSize }).then(res => {
          this.handleProductReview(res)
        })
      },
      productReviewPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productReviewPage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductReview: function(res){
        this.queryform.data = [];
        JSON.parse(res.data.data).forEach((d, index, arr) => {
          if(index < this.queryform.pageSize){
            if(d['groupGoodsSum'] && 1e4 < d['groupGoodsSum']){
              d['groupGoodsSum'] = (d['groupGoodsSum']/1e2>>0)/1e2
            }else{
              d['groupGoodsSum'] = 0.1
            }
            if(1 === d.status){
              d.statusName = '已投票';
            }else{
              d.statusName = '未投票';
            }
            d.fn = !d.status ? 'getVoteProduct' : 'getVoteProduct';
            d.operate = d.status ? '修改' : '投票';
            d.edit = !d.status ? true : false
            this.queryform.data.push(d);
          }
        });
        this.queryform.total = res.data.count;
      },
      getProductConfirm(){
        this.submitButtonLoading = true;
        let{ largeCategory, middleCategory, smallCategory, status, pageNo } = this.queryform
        this.productReviewPage({ largeCategory, middleCategory, smallCategory, groupCategory: 0, invalid: 0, pageNo, pageSize: 1000 }).then(res => {
          this.productList = [];
          let arr = []
          JSON.parse(res.data.data).forEach((d, index, array) => {
            if(d['goodsSum'] && 1e4 < d['goodsSum']){
              d['goodsSum'] = (d['goodsSum']/1e2>>0)/1e2
            }else{
              d['goodsSum'] = 0.1
            }
            if(1 === d.status){
              d.statusName = '已确认';
            }else{
              d.statusName = '未确认';
            }
            if(d.recordId && d.beWin){
              arr.push(d)
            }
            this.productList.push(d);
          });
          this.$refs.tableRef2.clearSelection();
          if(0 < arr.length){
            this.multipleSelection2 = [...arr]
          }else{
            this.multipleSelection2 = [...this.productList]
          }
          this.$nextTick(() => {
            this.multipleSelection2.forEach((o, index) => {
              this.$refs.tableRef2.toggleRowSelection(o, true);
            })
          });
          this.submitButtonLoading = false;
        })
      },
      getVoteProduct(w){
        this.submitButtonLoading = true;
        this.$api.memberApi.getVoteProduct({ invalid: 0,  groupNumber: w.groupNumber }).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              if(response.data.data){
                this.vote(w, JSON.parse(response.data.data));
              }
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'info' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      vote(w, items){
        this.productGroup.main = { ...w }
        this.productGroup.voteGroupName = `${w.largeCategory}/${w.middleCategory}/${w.smallCategory}「${w.ingredientPathway}」`;
        this.productGroup.voteMax = w.voteMax;

        this.productGroup.data = [...items]

        this.submitButtonLoading = false;
        this.dialogFormVisible = true;

        this.multipleSelection = [];
        this.$refs.tableRef.clearSelection();
        this.$nextTick(() => {
          items.forEach((o, index) => {
            if(o.recordId && o.beWin){
              this.$refs.tableRef.toggleRowSelection(o, true);
              this.multipleSelection.push(o)
            }
          })
        });
      },
      submitVote(){
        if(0 === this.multipleSelection.length){
          this.$confirm(`您未勾选生产企业，确定弃选？`, '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '返回检查',
            type: 'info'
          }).then(() => {
            this.submitButtonLoading = true;
            let arr = []
            this.productGroup.data.forEach(w => { arr.push({ productReviewId: w.id, status: 1, beWin: 0 }) })
            let objson = {};
            let { groupNumber } = { ...this.productGroup.main }
            Object.assign(objson,  {  groupNumber, recordList: arr } )
            this.$api.memberApi.submitVote(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.$message({ message: '保存成功！', offset: 200, type: 'success' });
                  this.nextGroup();
                }else{
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          }).catch(() => {

          });
        }else{
          this.submitButtonLoading = true;
          let arr = []
          let dataMap = new Map();
          this.multipleSelection.forEach(w => { dataMap.set(w.id, w) })
          this.productGroup.data.forEach(w => {
            if(dataMap.get(w.id)){
              arr.push({ productReviewId: w.id, status: 1, beWin: 1 })
            }else{
              arr.push({ productReviewId: w.id, status: 1, beWin: 0 })
            }
          })
          let objson = {};
          let { groupNumber } = { ...this.productGroup.main }
          Object.assign(objson,  {  groupNumber, recordList: arr } )
          this.$api.memberApi.submitVote(objson).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.$message({ message: '保存成功！', offset: 200, type: 'success' });
                this.nextGroup();
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }
      },
      submitConfirm(){
        if(0 == this.multipleSelection2.length){
          this.$message({ message: `请勾选品种后再进行「一键确认」！`, offset: 200, type: 'error' });
          return ;
        }

        this.$confirm(`您确定要「一键确认」吗？`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '返回检查',
          type: 'info'
        }).then(() => {
          this.submitButtonLoading = true;
          let list = this.multipleSelection2.map(w => { return w.id })
          this.$api.memberApi.submitConfirm({ids: list.join(',')}).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.$message({ message: '保存成功！', offset: 200, type: 'success' });
                this.getProductConfirm();
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }).catch(() => {

        });
      },
      nextGroup(){
        let groupNumber = this.productGroup.main.groupNumber;
        this.groupMap.forEach((v, k) => {
          if(k < this.groupMap.size && v.groupNumber == groupNumber){
            this.getVoteProduct(this.groupMap.get(++k));
            return;
          }
        })
      },
      prevGroup(){
        let groupNumber = this.productGroup.main.groupNumber;
        this.groupMap.forEach((v, k) => {
          if(0 < k && v.groupNumber == groupNumber){
            this.getVoteProduct(this.groupMap.get(--k));
            return;
          }
        })
      },
      closeDialogForm(){
        this.dialogFormVisible = false;
        this.getProductReview();
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      goLogin(msg) {
        this.$message({ message: msg, offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      }
    }
  }
</script>
<style>
.el-dialog__wrapper  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Member/ExpertReview.vue